import React from "react";
import PropTypes from "prop-types";

const Button = React.forwardRef((props, ref) => {
  return (
    <button
      className={props.btnClassname}
      type={props.btnType ? props.btnType : "button"}
      onClick={props.action}
      disabled={props.btnDisabled || props.loading}
      ref={ref}
      id={props.buttonId ? props.buttonId : ""}
      aria-label={props.label}
    >
      {((props.title && props.title.toLowerCase() !== "next") ||
        !props.title) &&
        props.children}
      <span
        className='spinner-border spinner-border-sm mr-2'
        role='status'
        aria-hidden='true'
        hidden={!props.loading}
      />
      {props.title}
      {props.title && props.title.toLowerCase() === "next" && props.children}
    </button>
  );
});

Button.propTypes = {
  btnClassname: PropTypes.string.isRequired,
  btnType: PropTypes.string,
  loading: PropTypes.bool,
  title: PropTypes.string.isRequired,
  action: PropTypes.func,
  btnDisabled: PropTypes.string,
  children: PropTypes.object,
  buttonId: PropTypes.string,
  label: PropTypes.string,
};

Button.displayName = "Button";

export default Button;
